import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { HrisConfigFragmentDoc } from '../hris/setupFlow/OrgHrisConfigContext.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisBaseQueryVariables = Types.Exact<{
  input: Types.HrisEmployeesInput;
}>;


export type HrisBaseQuery = { __typename?: 'Query', Me?: { __typename?: 'Me', user: { __typename?: 'Employee', id: number, org?: { __typename?: 'Org', id: number, hrisProvider?: string | null, hasAppliedHrisCsvUpload: boolean, hrisConfig: { __typename?: 'HrisConfig', id: string, finishedConnectingAt?: string | null, finishedLoadingAt?: string | null, dataVerifiedAt?: string | null, activatedAt?: string | null }, hrisIntegrations: Array<{ __typename?: 'HrisIntegration', id: string }> } | null } } | null, HrisEmployees: { __typename?: 'HrisEmployees', totalCount: number } };

export type HrisProtectedIntegrationsQueryVariables = Types.Exact<{
  sftpIntegrationsInput: Types.OrgSftpIntegrationsInput;
  mergeBackfillRunsInput: Types.MergeBackfillRunsInput;
  hrisCsvUploadsInput: Types.HrisCsvUploadsInput;
}>;


export type HrisProtectedIntegrationsQuery = { __typename?: 'Query', OrgSftpIntegrations: { __typename?: 'OrgSftpIntegrations', totalCount: number }, MergeBackfillRuns: { __typename?: 'MergeBackfillRuns', totalCount: number }, HrisCsvUploads: { __typename?: 'HrisCsvUploads', totalCount: number } };


export const HrisBaseDocument = gql`
    query HrisBase($input: HrisEmployeesInput!) {
  Me {
    user {
      id
      org {
        id
        hrisProvider
        hrisConfig {
          ...HrisConfig
        }
        hasAppliedHrisCsvUpload
        hrisIntegrations {
          id
        }
      }
    }
  }
  HrisEmployees(input: $input, pagination: {limit: 0}) {
    totalCount
  }
}
    ${HrisConfigFragmentDoc}`;

/**
 * __useHrisBaseQuery__
 *
 * To run a query within a React component, call `useHrisBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisBaseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHrisBaseQuery(baseOptions: Apollo.QueryHookOptions<HrisBaseQuery, HrisBaseQueryVariables> & ({ variables: HrisBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisBaseQuery, HrisBaseQueryVariables>(HrisBaseDocument, options);
      }
export function useHrisBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisBaseQuery, HrisBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisBaseQuery, HrisBaseQueryVariables>(HrisBaseDocument, options);
        }
export type HrisBaseQueryHookResult = ReturnType<typeof useHrisBaseQuery>;
export type HrisBaseLazyQueryHookResult = ReturnType<typeof useHrisBaseLazyQuery>;
export type HrisBaseQueryResult = Apollo.QueryResult<HrisBaseQuery, HrisBaseQueryVariables>;
export const HrisProtectedIntegrationsDocument = gql`
    query HrisProtectedIntegrations($sftpIntegrationsInput: OrgSftpIntegrationsInput!, $mergeBackfillRunsInput: MergeBackfillRunsInput!, $hrisCsvUploadsInput: HrisCsvUploadsInput!) {
  OrgSftpIntegrations(input: $sftpIntegrationsInput, pagination: {limit: 0}) {
    totalCount
  }
  MergeBackfillRuns(input: $mergeBackfillRunsInput, pagination: {limit: 0}) {
    totalCount
  }
  HrisCsvUploads(input: $hrisCsvUploadsInput, pagination: {limit: 0}) {
    totalCount
  }
}
    `;

/**
 * __useHrisProtectedIntegrationsQuery__
 *
 * To run a query within a React component, call `useHrisProtectedIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisProtectedIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisProtectedIntegrationsQuery({
 *   variables: {
 *      sftpIntegrationsInput: // value for 'sftpIntegrationsInput'
 *      mergeBackfillRunsInput: // value for 'mergeBackfillRunsInput'
 *      hrisCsvUploadsInput: // value for 'hrisCsvUploadsInput'
 *   },
 * });
 */
export function useHrisProtectedIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<HrisProtectedIntegrationsQuery, HrisProtectedIntegrationsQueryVariables> & ({ variables: HrisProtectedIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisProtectedIntegrationsQuery, HrisProtectedIntegrationsQueryVariables>(HrisProtectedIntegrationsDocument, options);
      }
export function useHrisProtectedIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisProtectedIntegrationsQuery, HrisProtectedIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisProtectedIntegrationsQuery, HrisProtectedIntegrationsQueryVariables>(HrisProtectedIntegrationsDocument, options);
        }
export type HrisProtectedIntegrationsQueryHookResult = ReturnType<typeof useHrisProtectedIntegrationsQuery>;
export type HrisProtectedIntegrationsLazyQueryHookResult = ReturnType<typeof useHrisProtectedIntegrationsLazyQuery>;
export type HrisProtectedIntegrationsQueryResult = Apollo.QueryResult<HrisProtectedIntegrationsQuery, HrisProtectedIntegrationsQueryVariables>;